export enum QuestMetaActions {
	START_CHAPTER_NARRATIVE = "startChapterNarrative",
}

export interface StartChapterNarrativeParams {
	chapter: number;
}

export type QuestMetaActionChapterConfig = {
	action: QuestMetaActions.START_CHAPTER_NARRATIVE;
	params: StartChapterNarrativeParams;
};

export type QuestMetaActionsConfig = Record<
	number,
	QuestMetaActionChapterConfig
>;

export const questMetaActionsConfig: QuestMetaActionsConfig = {
	35: {
		action: QuestMetaActions.START_CHAPTER_NARRATIVE,
		params: { chapter: 2 },
	},
	70: {
		action: QuestMetaActions.START_CHAPTER_NARRATIVE,
		params: { chapter: 3 },
	},
	105: {
		action: QuestMetaActions.START_CHAPTER_NARRATIVE,
		params: { chapter: 4 },
	},
};
